import { render, staticRenderFns } from "./error.vue?vue&type=template&id=6bfa8dec&scoped=true&"
import script from "./error.vue?vue&type=script&lang=js&"
export * from "./error.vue?vue&type=script&lang=js&"
import style0 from "./error.vue?vue&type=style&index=0&id=6bfa8dec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa8dec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CookieConsent: require('/var/www/jaty-frontend/components/CookieConsent.vue').default,OfflineTooltip: require('/var/www/jaty-frontend/components/OfflineTooltip.vue').default})
